export const SENTRY_APPLICATION_KEY = "planima-browser";
